export default "__VITE_ASSET__5203407e__"